import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtSectionButton from "../general/NtSectionButton";

function NtPlansSection(props) {
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/3e9705511f19a42561e30c83f1cb2fc0e029aeba.jpg")}
    >
      <NtSectionTitle style={{ marginTop: 150, fontSize: 28 }}>
        RESIDENTIAL VOIP PHONE{"\n"}SERVICE
      </NtSectionTitle>
      <NtSectionDescription style={{ marginTop: 10 }}>
        Crystal clear and reliable calls on uor new IP Network.
      </NtSectionDescription>

      <View
        style={{
          marginTop: 30,
          padding: 10,
          borderRadius: 10,
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(10px)",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Image
          style={[
            {
              width: 150,
              height: 120,
              borderRadius: 10,
              resizeMode: "contain",
            },
          ]}
          source={require("../../../assets/images/marketing/7e7d3d9f7528a6b4e69a195a3b9e624ca4ff7104.png")}
        />
        <View
          style={{ marginLeft: 10, alignItems: "flex-start", paddingRight: 50 }}
        >
          <NtSectionDescription style={{ fontWeight: "700", fontSize: 13 }}>
            Register an ezLINQ
          </NtSectionDescription>
          <NtSectionDescription
            style={{ fontWeight: "300", fontSize: 12, marginTop: 6 }}
          >
            bought on Amazon
          </NtSectionDescription>

          <NtSectionButton
            containerStyle={{ marginTop: 15 }}
            title="Register Now"
            color="white"
            onPress={() => {
              window.open(
                "https://my.ntconnect.com/phone/activation/registerbyod"
              );
            }}
          />
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    height: 550,
  },
});

export default NtPlansSection;
